import LoadingScreen from '../components/LoadingScreen';
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';
import { useAppContext } from '../context/AppContext';

const formatDeliveryDate = (day) => {
  if (!day) return '—';
  const parts = day.split('-');
  if (parts.length !== 3) return day;
  return `${parts[2]}.${parts[1]}.${parts[0]}`;
};

export default function AdminMyWorkScreen() {
  const navigate = useNavigate();
  const { user } = useAppContext();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadOrders = useCallback(async () => {
    try {
      const data = await api.orders.adminAll();
      setOrders((data || []).filter(o => String(o.courier_id) === String(user?.id)));
    } catch {} finally { setLoading(false); }
  }, [user]);

  useEffect(() => { if (user?.id) loadOrders(); else setLoading(false); }, [user, loadOrders]);

  const handleRelease = async (orderId, e) => {
    e.stopPropagation();
    if (!window.confirm('Вернуть заказ в общий список?')) return;
    try {
      await api.orders.release(orderId);
      setOrders(prev => prev.filter(o => o.id !== orderId));
    } catch { alert('Не удалось убрать заказ'); }
  };

  if (loading) return <LoadingScreen />;

  return (
    <div style={{ paddingBottom: 100 }}>
      <div style={{ display: 'flex', alignItems: 'center', padding: '12px 16px', borderBottom: '1px solid var(--border)', background: 'var(--card)', gap: 12 }}>
        <button onClick={() => navigate(-1)} style={{ background: 'none', color: 'var(--primary)', fontSize: 22, fontWeight: 600, cursor: 'pointer', padding: 0 }}>←</button>
        <h1 style={{ fontWeight: 700, fontSize: 16, flex: 1, textAlign: 'center' }}>Мои заказы</h1>
        <div style={{ width: 40 }} />
      </div>

      <div style={{ padding: '0 16px' }}>
        <p style={{ fontSize: 13, color: 'var(--text-light)', marginTop: 12, marginBottom: 12 }}>
          {orders.length} {orders.length === 1 ? 'заказ' : orders.length < 5 ? 'заказа' : 'заказов'} в работе
        </p>

        {orders.length === 0 ? (
          <div style={{ background: 'var(--card)', borderRadius: 14, padding: 24, textAlign: 'center' }}>
            <p style={{ fontWeight: 700, marginBottom: 4 }}>Нет заказов в работе</p>
            <p style={{ fontSize: 13, color: 'var(--text-light)' }}>Возьмите заказы из общего списка</p>
          </div>
        ) : orders.map(order => (
          <div key={order.id} onClick={() => navigate(`/admin-order/${order.id}`)}
            style={{ background: 'var(--card)', borderRadius: 12, padding: 16, marginBottom: 12, borderLeft: '3px solid #4CAF50', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', cursor: 'pointer' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
              <span style={{ fontWeight: 700, fontSize: 16 }}>{formatDeliveryDate(order.delivery_day)}</span>
              {order.city && <span style={{ fontSize: 13, color: 'var(--primary)', fontWeight: 600 }}>{order.city}{order.district ? ` · ${order.district}` : ''}</span>}
            </div>
            <div style={{ fontSize: 14, marginBottom: 4 }}>{order.address}</div>
            {order.brand && <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--primary)', marginBottom: 2 }}>{order.brand}{order.volume ? ` ${order.volume}` : ''}</div>}
            <div style={{ fontSize: 13, color: 'var(--text-light)', marginBottom: 4 }}>Бутыли: {order.quantity}{order.exchange_count ? ` · Обмен: ${order.exchange_count}` : ''}</div>
            {order.comment && <div style={{ fontSize: 13, color: '#E53935', fontStyle: 'italic', marginBottom: 8 }}>{order.comment}</div>}
            <button onClick={e => handleRelease(order.id, e)} style={{ width: '100%', padding: '8px', borderRadius: 8, border: '1.5px solid #FF9500', background: 'none', color: '#FF9500', fontWeight: 700, fontSize: 13, cursor: 'pointer', marginTop: 8 }}>
              Убрать из работы
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

const centered = { display: 'flex', alignItems: 'center', justifyContent: 'center', height: '80vh', fontSize: 16, color: 'var(--text-light)' };
